@defer (when issue()) {
  @if (hasPageTitle) {
    <div (click)="goBack()">
      <app-page-title [canGoBack]="true" [label]="issue().title" />
    </div>
  }
  <main class="content-container" [class.is-dragging]="isDragging" [class.is-mobile]="isMobile">
    <header>
      <app-toolbar [size]="isMobile ? 'small' : 'medium'">
        <div class="right">
          <!--
          @if (issue().status === 'open' || issue().status === 'in progress') {
            <app-button label="Link entity" icon="mdi mdi-link" title="Org, sites, gateways, assets or users" (click)="linkEntity()" />
          }
          <i class="mdi mdi-circle-small divider"></i>
        -->
          <app-button (click)="edit()" label="Update" icon="mdi mdi-text-box-edit-outline" [size]="isMobile ? 'small' : 'medium'" />
          <i class="mdi mdi-circle-small divider"></i>
          @if (issue().buildingReview?.documentKey) {
            <a href="https://s3.eu-west-2.amazonaws.com/4d-documents/{{ issue().buildingReview.documentKey }}" target="_blank">
              <app-button label="View Review" icon="mdi mdi-book-open-variant-outline" [size]="isMobile ? 'small' : 'medium'" />
            </a>

            <!--<i class="mdi mdi-circle-small divider"></i>-->
          }
          <!-- @todo add complete button
          <app-button (click)="complete()" label="Complete" icon="mdi mdi-check" /> -->
          <!--
          <app-button (click)="ChangeStatus()" label="Change Status" icon="mdi mdi-pencil" />
        --></div>
      </app-toolbar>
    </header>
    @if (issue().sites?.length) {
      <section>
        <div class="flex site-header">
          <div class="flex-1">Site</div>
          <div class="flex-1">Address</div>
        </div>
        <div class="flex">
          <div class="flex-1">{{ issue().sites[0].title }}</div>
          <div class="flex-1">{{ issue().sites[0].addressDisplayForLine() }}</div>
        </div>
      </section>
    }
    <section class="details">
      <h2>Details</h2>
      <!--
      <div class="tags">
        @if (issue().orgs.length) {
          @for (org of issue().orgs; track $index) {
            <app-chip [canClick]="false" [label]="org.title" icon="mdi mdi-domain" title="Org" />
          }
        }
        @if (issue().users.length) {
          @for (user of issue().users; track $index) {
            <app-chip [canClick]="false" [label]="user.name" icon="mdi mdi-account" title="User" />
          }
        }
        @if (issue().buildingReview) {
          <app-chip [canClick]="false" [label]="issue().buildingReview.documentTitle" icon="mdi mdi-file-pdf-box" title="Building Review" />
        }
        @if (issue().attachments.length) {
          @for (attachment of issue().attachments; track $index) {
            <a target="_blank" href="https://s3.eu-west-2.amazonaws.com/4d-documents/{{ attachment.key }}">
              <app-chip [label]="attachment.filename" icon="mdi mdi-attachment" title="Download" />
            </a>
          }
        }
      </div>
    -->

      <div>
        <div class="description preserve-formatting">
          {{ issue().description }}
        </div>
        <div class="status-line">
          <div class="">
            <span>Status</span> {{ issue().status }}
            @if (issue().status !== 'created') {
              <i class="mdi mdi-chevron-double-right"></i> {{ issue().subStatusTitle }}
            }
          </div>
          @if (issue().assigneeName) {
            <div class=""><span>Assignee</span> {{ issue().assigneeName || 'not assigned' }}</div>
          }

          <div class=" {{ issue().rag }}"><span>RAG</span> {{ issue().rag }}</div>
          <div class="flex-1 text-right created"><span>Created</span> {{ issue().createdAt | amTimeAgo }} by {{ issue().createdByName }}</div>
        </div>
      </div>
    </section>
    @if (issue().completedNotes) {
      <section class="details">
        <h2>Completed Notes</h2>
        <div class="description preserve-formatting">
          {{ issue().completedNotes }}
        </div>
      </section>
    }
    <section>
      <h2>Comments</h2>
      <app-issue-tracking-comments [issue]="issue()" (onUpated)="reload()" />
    </section>

    @if (issue().hasAssets) {
      <section>
        <h2>
          Assets
          @if (issue().points?.[0]?.fromDate) {
            <span class="smaller">( {{ issue().points[0].fromDate | date: 'dd/MM/yy' }} to {{ issue().points[0]?.toDate | date: 'dd/MM/yy' }})</span>
          }
        </h2>

        <div>
          @if (assets()) {
            @for (assetContainer of assets(); track assetContainer.asset.id) {
              <h3>{{ assetContainer.asset.title }}</h3>
              <div class="chart" [class.has-telemetry]="assetContainer.telemetry?.length">
                @if (assetContainer.telemetry?.length) {
                  <app-d3-chart [asset]="assetContainer.asset" [hasToClickToInteract]="true" [canAnnotate]="true" [canZoom]="false" [height]="200" [telemetry]="assetContainer.telemetry" [annotations]="assetContainer.annotations ?? null" [showLegend]="true" [minMaxFromData]="false" [penWidth]="0.8" [dateFrom]="chartRange()?.from" [dateTo]="chartRange()?.to" />
                } @else {
                  <app-preloader />
                }
              </div>
            }
          }
        </div>
      </section>
    }
    @if (!isMobile) {
      <section class="mb-1">
        <h2>Audit</h2>
        <app-issue-tracking-audit [issue]="issue()" (onCompleteIssueUsingDate)="completeIssueUsingDate($event)"></app-issue-tracking-audit>
      </section>
    }
    @if (documentLink) {
      <embed [src]="documentLink" type="application/pdf" width="100%" height="600px" />
    }
  </main>
} @placeholder {
  <i class="mdi mdi-loading mdi-spin-x2"></i>
}

@switch (dialogOpen()) {
  @case ('verify_entity') {
    <app-dialog header="Verify adding entity" (onClose)="dialogOpen.set(null)" [dimensions]="{ width: 620, height: 180 }">
      <section>
        <p>
          Add new
          @switch (newEntity.field) {
            @case ('org_id') {
              organisation
            }
            @case ('site_id') {
              site
            }
            @case ('gateway_id') {
              gateway
            }
            @case ('asset_id') {
              asset
            }
            @case ('user_id') {
              user
            }
            @default {
              {{ newEntity | json }}
            }
          }
          <app-chip [label]="newEntity.title" /> to the {{ issue().issueType }}?

          @switch (newEntity.field) {
            @case ('org_id') {
              <p>
                <span class="can-click" (click)="newEntity.isDefault = !newEntity.isDefault"> <i class="mdi" [class.mdi-checkbox-marked-outline]="newEntity.isDefault" [class.mdi-checkbox-blank-outline]="!newEntity.isDefault"></i> Make this the Organisation for the {{ issue().issueType }}. <i class="mdi mdi-information-slab-circle-outline" title="If not checked, this is just a reference to the org."></i> </span>
              </p>
            }
          }
        </p>
      </section>
      <section>
        <app-toolbar [hasBackground]="false">
          <div class="right">
            <app-button label="Save" icon="mdi mdi-check" (click)="userVerifiedAddingEntity()" />
          </div>
        </app-toolbar>
      </section>
    </app-dialog>
  }
  @case ('entities') {
    <app-dialog header="Entities for {{ issue().org?.title }}" (onClose)="dialogOpen.set(null)" [canScroll]="false">
      @if (issue()) {
        <app-issue-tracking-entity-picker [org]="issue().org" [entities]="issue().entities" (onChanged)="entitiesSelected($event)" />
      }
    </app-dialog>
  }
  @case ('edit') {
    <app-dialog [canScroll]="false" [dimensions]="{ width: 880, height: 460 }" header="Update Issue" (onClose)="dialogOpen.set(null)">
      <app-issue-tracking-update [issueId]="issue().id" (onUpdated)="issueUpdated($event)" (onCompleted)="issueCompleted($event)" />
    </app-dialog>
  }
  @case ('status') {
    <app-dialog header="Change Status" (onClose)="dialogOpen.set(null)" [dimensions]="{ width: 520, height: 410 }">
      <section class="statuses">
        <div (click)="setStatus('open')">
          <app-button label="This issue is open" [isBlock]="true" [isDisabled]="issue().status === 'open'" />
        </div>
        <div (click)="setStatus('in progress')">
          <app-button label="This issue is in progress" [isBlock]="true" [selected]="wantsStatus() === 'in progress'" />
        </div>
        <div (click)="setStatus('no action required')">
          <app-button icon="mdi mdi-check" label="There is no action required and has been completed" [isBlock]="true" iconPos="right" [selected]="wantsStatus() === 'no action required'" />
        </div>
        <div (click)="setStatus('completed')">
          <app-button icon="mdi mdi-check" label="This has been completed" [isBlock]="true" iconPos="right" [selected]="wantsStatus() === 'completed'" />
        </div>
      </section>
      @if (wantsStatus() === 'in progress' || wantsStatus() === 'completed') {
        <section class="mt-1 notes content-container">
          <h4>Proposed Action</h4>
          <textarea class="fourd" rows="3" [(ngModel)]="proposedAction"></textarea>
        </section>
      }
      @if (wantsStatus()) {
        <section class="text-right mt-1">
          <app-button icon="mdi mdi-check" (click)="saveStatus()" label="Save" />
        </section>
      }
    </app-dialog>
  }
}

@switch (dialogConfirm()) {
  @case ('delete') {
    <app-dialog [dimensions]="{ width: 490, height: issue().createdByName === user.name ? 160 : 180 }" (onClose)="dialogConfirm.set(null)" header="Delete this Issue?">
      <section class="content-container">
        <h3 class="mt-1 mb-1"><i class="mdi mdi-alert red"></i> You are about to delete this issue and it's history</h3>
        @if (issue().createdByName !== user.name) {
          <p class="text-center red"><b>This issue was not created by you.</b></p>
        }
        <app-toolbar [hasBackground]="false">
          <div class="right">
            <app-button label="Cancel" icon="mdi mdi-close" (click)="dialogConfirm.set(null)" class="mr-1" />

            <app-button label="DELETE" icon="mdi mdi-trash-can-outline" (click)="deleteClick('YES')" />
          </div>
        </app-toolbar>
      </section>
    </app-dialog>
  }
}
